import { useEffect, useState } from "react"
import axios from "axios"
import { useFormDataContext } from "../../../providers/form"
import { ENDPOINTS } from "../../../constants/endpoints"
import { useSessionsDataContext } from "../providers/sessions"
import { usePastSessionsDataContext } from "../providers/pastSessions"
import { useUpcomingSessionsDataContext } from "../providers/upcomingSessions"
import useIsLoading from "../../../hooks/useIsLoading";
import useValidation from "../../../hooks/useValidations";
import { useToast } from "../../app/components/ToastContext"
import api from "../../../helpers/api"
function useCreateEditSession(sessionId = null, onHide) {
    const sessionData = useSessionsDataContext()
    const pastSessionData = usePastSessionsDataContext()
    const upcomingSessionData = useUpcomingSessionsDataContext()
    const formData = useFormDataContext()
    const { successToast } = useToast()
    //const [loading, setLoading] = useState(false)
    //const [validations, setValidations] = useState({})
    const [progress, setProgress] = useState(0)
    // const handleValidations = () => ({
    //     clear: () => setValidations({})
    // })
    const {
        loading,
        setLoading
    } = useIsLoading()
    const {
        handleValidations,
        validations,
    } = useValidation()
    async function handleSave(data, resetForm, type, isSession = true, showSuccess) {
        if (loading) return
        setLoading(true)
        handleValidations().clear()
        const endpoint = sessionId ? ENDPOINTS.SESSIONS.UPDATE : ENDPOINTS.SESSIONS.CREATE
        try {
            const response = await api.post(endpoint, data, {
                headers: { 'Content-Type': 'multipart/form-data' },
                onUploadProgress: (progressEvent) => {
                    const percent = Math.round(
                        (progressEvent.loaded * 100) / progressEvent.total
                    )
                    setProgress(percent)
                    console.log(percent)
                },
            })
            if (response.status === 200) {
                if (type === 'upcoming') upcomingSessionData.refetchDataUpcoming(upcomingSessionData.getCurrentPageUpcoming())
                if (type === 'past') pastSessionData.refetchDataPast(pastSessionData.getCurrentPagePast())
                sessionId ?? resetForm()
                isSession ?? resetForm()
                onHide()
                successToast(sessionId ? 'Успешно запазихте промените' : 'Успешно добавихте заседание')
                if (data.get('type') == 'files') window.location.reload()
            } else {
                console.error('Request failed with status:', response.status)
            }
        } catch (error) {
            console.error('An error occurred:', error)
            if (error.response && error.response.data.errors) {
                //setValidations(error.response.data.errors)
            }
        } finally {
            setLoading(false)
        }
    }
    return {
        loading,
        handleSave,
        validations,
        handleValidations,
        getProgress: progress,
    }
}
export default useCreateEditSession